import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getConAanData, getConAanData_currency } from "@/api/dataAll/congroupAnal";
import * as echarts from "echarts";
export default {
  name: "congroupAnal",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        activatetime: ""
      },
      tableData: [],
      tableLtv: [],
      dates: [],
      show: false,
      activity_device_arr: [],
      register_arr: [],
      create_role_arr: [],
      login_time_arr: [],
      sum_login_time_arr: [],
      recharge_time_arr: [],
      sum_recharge_time_arr: [],
      pay_amount_arr: [],
      sum_pay_amount_arr: [],
      arpu_arr: [],
      sum_arpu_arr: [],
      arppu_arr: [],
      sum_arppu_arr: [],
      ltv_arr: [],
      isgetdataCurrency: true
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqFn = _this.currencyClose ? getConAanData_currency : getConAanData;

                _this.searchClickPoints(reqFn, 1);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var qres, res, dataArr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                qres = JSON.parse(JSON.stringify(lists));
                res = {
                  data: []
                };
                qres.forEach(function (i) {
                  res.data.push(i[0]);
                });
                _this2.dates = [];
                _this2.activity_device_arr = [];
                _this2.register_arr = [];
                _this2.create_role_arr = [];
                _this2.login_time_arr = [];
                _this2.sum_login_time_arr = [];
                _this2.recharge_time_arr = [];
                _this2.sum_recharge_time_arr = [];
                _this2.pay_amount_arr = [];
                _this2.sum_pay_amount_arr = [];
                _this2.arpu_arr = [];
                _this2.sum_arpu_arr = [];
                _this2.arppu_arr = [];
                _this2.sum_arppu_arr = [];
                _this2.ltv_arr = [];
                _context2.next = 20;
                return _this2.getexchangeRate();

              case 20:
                dataArr = [];
                res.data.forEach(function (item, index) {
                  item.id = index + 1;
                  item.pay_amountexchange = _this2.isyjfmvnd() ? (Number(item.pay_amount) * _this2.exchangeRate).toFixed(3) : _this2.$utils.conversion(Number(item.pay_amount) * _this2.exchangeRate).toFixed(3);
                  item.pay_amount = _this2.isyjfmvnd() ? item.pay_amount : _this2.$utils.conversion(item.pay_amount);
                  item.sum_pay_amountexchange = _this2.isyjfmvnd() ? (Number(item.sum_pay_amount) * _this2.exchangeRate).toFixed(3) : _this2.$utils.conversion(Number(item.sum_pay_amount) * _this2.exchangeRate).toFixed(3);
                  item.sum_pay_amount = _this2.isyjfmvnd() ? item.sum_pay_amount : _this2.$utils.conversion(item.sum_pay_amount);
                  item.arpu = _this2.$utils.conversion(item.arpu).toFixed(2);
                  item.sum_arpu = _this2.$utils.conversion(item.sum_arpu).toFixed(2);
                  item.ltv = _this2.$utils.conversion(item.ltv).toFixed(2);
                  item.arppu = _this2.$utils.conversion(item.arppu).toFixed(2);
                  item.sum_arppu = _this2.$utils.conversion(item.sum_arppu).toFixed(2);
                  item.activity_device = Number(item.activity_device);
                  item.create_role = Number(item.create_role);

                  _this2.activity_device_arr.push(item.activity_device);

                  _this2.register_arr.push(item.register);

                  _this2.create_role_arr.push(item.create_role);

                  _this2.login_time_arr.push(item.login_time);

                  _this2.sum_login_time_arr.push(item.sum_login_time);

                  _this2.recharge_time_arr.push(item.recharge_time);

                  _this2.sum_recharge_time_arr.push(item.sum_recharge_time);

                  _this2.pay_amount_arr.push(item.pay_amount);

                  _this2.sum_pay_amount_arr.push(item.sum_pay_amount);

                  _this2.arpu_arr.push(item.arpu);

                  _this2.sum_arpu_arr.push(item.sum_arpu);

                  _this2.arppu_arr.push(item.arppu);

                  _this2.sum_arppu_arr.push(item.sum_arppu);

                  _this2.ltv_arr.push(item.ltv);
                });
                _this2.tableData = res.data || []; // this.tableData = dataArr

                _this2.dates = _this2.tableData.map(function (v) {
                  return v.date;
                });
                _this2.echarts = true;

                _this2.getechart();

                _this2.$nextTick(function () {
                  _this2.getTableRight();
                });

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("congroupAnalEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('congroupAnalysis')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        toolbox: {
          feature: {
            // magicType: { show: true, type: ['line', 'bar'] },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        legend: {
          data: [this.$t('activateDeviceNum'), this.$t('register'), this.$t('createRoleCount'), this.$t('loginDeviceCount'), this.$t('sumLoginDeviceCount'), this.$t('payDeviceCount'), this.$t('sumPayDeviceCount'), this.$t('dailyPayAmount'), this.$t('sumPayAmount'), this.$t('dailyArpu'), this.$t('sumArpu'), this.$t('dailyArppu'), this.$t('sumArppu'), "ltv"],
          width: '80%'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.dates
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: this.$t('activateDeviceNum'),
          type: "line",
          data: this.activity_device_arr,
          smooth: true
        }, {
          name: this.$t('register'),
          type: "line",
          data: this.register_arr,
          smooth: true
        }, {
          name: this.$t('createRoleCount'),
          type: "line",
          data: this.create_role_arr,
          smooth: true
        }, {
          name: this.$t('loginDeviceCount'),
          type: "line",
          data: this.login_time_arr,
          smooth: true
        }, {
          name: this.$t('sumLoginDeviceCount'),
          type: "line",
          data: this.sum_login_time_arr,
          smooth: true
        }, {
          name: this.$t('payDeviceCount'),
          type: "line",
          data: this.recharge_time_arr,
          smooth: true
        }, {
          name: this.$t('sumPayDeviceCount'),
          type: "line",
          data: this.sum_recharge_time_arr,
          smooth: true
        }, {
          name: this.$t('dailyPayAmount'),
          type: "line",
          data: this.pay_amount_arr,
          smooth: true
        }, {
          name: this.$t('sumPayAmount'),
          type: "line",
          data: this.sum_pay_amount_arr,
          smooth: true
        }, {
          name: this.$t('dailyArpu'),
          type: "line",
          data: this.arpu_arr,
          smooth: true
        }, {
          name: this.$t('sumArpu'),
          type: "line",
          data: this.sum_arpu_arr,
          smooth: true
        }, {
          name: this.$t('dailyArppu'),
          type: "line",
          data: this.arppu_arr,
          smooth: true
        }, {
          name: this.$t('sumArppu'),
          type: "line",
          data: this.sum_arppu_arr,
          smooth: true
        }, {
          name: "ltv",
          type: "line",
          data: this.ltv_arr,
          smooth: true
        }]
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [// {
      //   label: 'ID',
      //   prop: 'id'
      // }, 
      {
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('activateDeviceNum'),
        prop: 'activity_device'
      }, {
        label: this.$t('register'),
        prop: 'register'
      }, {
        label: this.$t('createRoleCount'),
        prop: 'create_role'
      }, {
        label: this.$t('loginDeviceCount'),
        prop: 'login_time'
      }, {
        label: this.$t('sumLoginDeviceCount'),
        prop: 'sum_login_time'
      }, {
        label: this.$t('payDeviceCount'),
        prop: 'recharge_time'
      }, {
        label: this.$t('sumPayDeviceCount'),
        prop: 'sum_recharge_time'
      }, {
        label: this.$t('dailyPayAmount'),
        prop: 'pay_amount'
      }, {
        label: this.$t('sumPayAmount'),
        prop: 'sum_pay_amount'
      }, {
        label: this.$t('dailyArpu'),
        prop: 'arpu'
      }, {
        label: this.$t('sumArpu'),
        prop: 'sum_arpu'
      }, {
        label: this.$t('dailyArppu'),
        prop: 'arppu'
      }, {
        label: this.$t('sumArppu'),
        prop: 'sum_arppu'
      }, {
        label: "ltv",
        prop: 'ltv'
      }];
      var exchangePVND = [{
        label: this.$t('dailyPayAmountVnd'),
        prop: 'pay_amountexchange'
      }];
      var exchangeSVND = [{
        label: this.$t('sumPayAmountVnd'),
        prop: 'sum_pay_amountexchange'
      }];
      var exchangePUSD = [{
        label: this.$t('dailyPayAmountUsd'),
        prop: 'pay_amountexchange'
      }];
      var exchangeSUSD = [{
        label: this.$t('sumPayAmountUsd'),
        prop: 'sum_pay_amountexchange'
      }];
      var data = this.tableData;

      if (this.queryCurrency == "USD") {// exchangePVND.unshift(9, 0);
        // exchangeSVND.unshift(11, 0);
        // Array.prototype.splice.apply(columns, exchangePVND);
        // Array.prototype.splice.apply(columns, exchangeSVND);
      }

      if (this.queryCurrency == "VND") {
        exchangePUSD.unshift(9, 0);
        exchangeSUSD.unshift(11, 0);
        Array.prototype.splice.apply(columns, exchangePUSD);
        Array.prototype.splice.apply(columns, exchangeSUSD);
      }

      this.$export.Excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    } // handleCurrentChange(val) {},

  }
};